import { colors } from 'shared/core';

const primaryTheme = {
	colors: {
		documentLink: colors.white,
	},
};

export default primaryTheme;
